import type { BenefitsSectionFragment } from '@/lib/types/datocms/graphql/generated'
import { TextWithHighlight } from '../TextWithHighlight'
import Eyebrow from '../ui/Eyebrow'
import BenefitCard from '../BenefitCard'
import { isStructuredTextEmpty } from '@/utils/datocms/isStructuredTextEmpty'
import CtaDefault from '../ui/cta/CtaDefault'

export default function BenefitsSection({
	title,
	tag,
	items,
	cta,
}: Readonly<BenefitsSectionFragment>) {
	return (
		<section className="benefits-section @container">
			<div className="flex flex-col common-x-padding py-16 @5xl:py-24 max-w-screen-2xl mx-auto">
				<div className="flex flex-wrap justify-between gap-10">
					<div>
						{tag ? <Eyebrow>{tag}</Eyebrow> : null}
						{title && !isStructuredTextEmpty(title.text) && (
							<div className="heading-size-2 mt-6 xl:mt-10">
								<TextWithHighlight text={title} />
							</div>
						)}
					</div>
					{cta && <CtaDefault cta={cta} className="mt-auto" />}
				</div>
				<div className="grid grid-cols-1 @xl:grid-cols-2 @5xl:grid-cols-3 gap-2 @xl:gap-5 mt-16">
					{items.map((item) => (
						<BenefitCard key={item.id} {...item} />
					))}
				</div>
			</div>
		</section>
	)
}
